import { useCallback } from 'react';
import { MapScope } from '@/graphql/types';
import type { MapMarker } from './graphql/useMapMarkersQuery';

interface UseMapPageActionsArgs {
    scope: MapScope;
    userId: number | null | undefined;
}

type InfoWindowContent = string | Element | Text;

function getHijackForm() {
    return document.getElementById('map-hijack-form') as HTMLFormElement | null;
}

function redirectToMeasuringPoint(measuringPointId: number) {
    window.location.href = `/sbr/sbrView/#${measuringPointId}`;
}

function createInfoWindowContent(text: string): InfoWindowContent {
    const wrapper = document.createElement('div');
    wrapper.textContent = text;
    return wrapper;
}

function hijackUser(ownerUserId: number) {
    const hijackForm = getHijackForm();
    if (!hijackForm) {
        throw new Error('Cannot hijack user: the hijack form is missing from the page.');
    }

    hijackForm.action = `/hijack/${ownerUserId}/`;
    hijackForm.submit();
}

export function useMapPageActions({ scope, userId }: UseMapPageActionsArgs) {
    const renderInfoWindowContent = useCallback(
        (marker: MapMarker) =>
            createInfoWindowContent(`${gettext('MAP_MARKER_SENSOR_LABEL')}: ${marker.name}`),
        []
    );

    const onMarkerDoubleClick = useCallback(
        (marker: MapMarker) => {
            if (scope === MapScope.Admin) {
                if (userId == null) {
                    throw new Error(
                        'Cannot resolve marker action: userId is missing in ADMIN scope.'
                    );
                }

                if (userId !== marker.ownerUserId) {
                    hijackUser(marker.ownerUserId);
                    return;
                }
            }

            redirectToMeasuringPoint(marker.measuringPointId);
        },
        [scope, userId]
    );

    return {
        onMarkerDoubleClick,
        renderInfoWindowContent,
    };
}
